import React from 'react'
import TaskForm from './TaskForm'
import {Modal} from 'react-bootstrap'


const TaskEdit = ({show,handleModalClose,handleSubmit,task}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Seite bearbeiten</Modal.Title>
        </Modal.Header>
          <TaskForm
             handleSubmit={handleSubmit} task={task}
            />
        </Modal>
  </div>
)

export default TaskEdit